
import React from "react";
import Hero from "../../components/Hero";
import MaterialsSection from "../../components/MaterialsSection";
import AboutSection from "../../components/AboutSection";
import ContactSection from "../../components/ContactSection";
import Footer from "../../components/Footer";

const Index = () => {
  console.log("🏠 PublicIndex component is rendering!");
  console.log("🌍 Current URL:", window.location.href);
  console.log("📍 Current pathname:", window.location.pathname);
  
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Hero />
      <MaterialsSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
